
export class DateFilter {
    startDate: Date;
    endDate: Date;
}